import { useContext } from "react";
import CarrierLogisticsCommonsContext from "../../context/CarrierLogisticsCommonsContext";
export function useLogisticParties() {
    var carrierLogisticsCommons = useContext(CarrierLogisticsCommonsContext);
    return carrierLogisticsCommons === null || carrierLogisticsCommons === void 0 ? void 0 : carrierLogisticsCommons.lps;
}
export default useLogisticParties;

//# sourceMappingURL=useLogisticParties.js.map